<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('rechargeSetting.queryCondition') }}</span>
            <div class="card-header-right">
              <el-button type="primary" size="small" @click="openAddRechargeSettingModal">
                <i class="el-icon-plus"></i>
                {{ $t('rechargeSetting.add') }}
              </el-button>
            </div>
          </div>

          <el-form :inline="true" :model="rechargeSettingManageInfo.conditions" class="query-form">
            <el-form-item>
              <el-select 
                v-model="rechargeSettingManageInfo.conditions.rechargeType" 
                :placeholder="$t('rechargeSetting.rechargeTypePlaceholder')" 
                style="width: 180px;"
                clearable>
                <el-option v-for="(item, index) in rechargeTypeOptions" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="queryRechargeSettingMethod">
                <i class="el-icon-search"></i>
                {{ $t('rechargeSetting.query') }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="exportRechargeSetting">
                <i class="el-icon-download"></i>
                {{ $t('rechargeSetting.export') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('rechargeSetting.title') }}</span>
          </div>

          <el-table
            :data="rechargeSettingManageInfo.rechargeSettings"
            style="width: 100%"
            border
            stripe>
            <el-table-column
              prop="id"
              :label="$t('rechargeSetting.id')"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="rechargeType"
              :label="$t('rechargeSetting.rechargeType')"
              align="center"
              width="120">
              <template slot-scope="scope">
                {{ getRechargeTypeLabel(scope.row.rechargeType) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="notice"
              :label="$t('rechargeSetting.notice')"
              align="center">
            </el-table-column>
            <el-table-column
              :label="$t('rechargeSetting.amountList')"
              align="center"
              width="300">
              <template slot-scope="scope">
                <div v-if="scope.row.amountList" class="amount-list">
                  <div v-for="(item, index) in formatAmountList(scope.row.amountList)" :key="index" class="amount-item">
                    <span class="amount-label">支付</span>
                    <span class="amount-value discount">{{ item.discountAmount }}</span>
                    <span class="amount-arrow">→</span>
                    <span class="amount-label">优惠</span>
                    <span class="amount-value face">{{ item.faceAmount }}</span>
                    <span class="amount-unit">元</span>
                  </div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('rechargeSetting.fastAmountList')"
              align="center"
              width="300">
              <template slot-scope="scope">
                <div v-if="scope.row.fastAmountList" class="amount-list">
                  <div v-for="(item, index) in formatAmountList(scope.row.fastAmountList)" :key="index" class="amount-item">
                    <span class="amount-label">支付</span>
                    <span class="amount-value discount">{{ item.discountAmount }}</span>
                    <span class="amount-arrow">→</span>
                    <span class="amount-label">优惠</span>
                    <span class="amount-value face">{{ item.faceAmount }}</span>
                    <span class="amount-unit">元</span>
                  </div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="lowTime"
              :label="$t('rechargeSetting.lowTime')"
              align="center"
              width="120">
              <template slot-scope="scope">
                {{ scope.row.lowTime ? scope.row.lowTime + '' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="fastTime"
              :label="$t('rechargeSetting.fastTime')"
              align="center"
              width="120">
              <template slot-scope="scope">
                {{ scope.row.fastTime ? scope.row.fastTime + '' : '-' }}
              </template>
            </el-table-column>
           <!--  <el-table-column
              prop="remark"
              :label="$t('rechargeSetting.remark')"
              align="center">
            </el-table-column> -->
           <!--  <el-table-column
              prop="discountRate"
              :label="$t('rechargeSetting.discountRate')"
              align="center"
              width="120">
            </el-table-column> -->
           <!--  <el-table-column
              prop="sort"
              :label="$t('rechargeSetting.sort')"
              align="center"
              width="80">
            </el-table-column> -->
            <el-table-column
              :label="$t('rechargeSetting.operation')"
              align="center"
              >
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="openEditRechargeSettingModel(scope.row)">
                    {{ $t('rechargeSetting.edit') }}
                  </el-button>
                  <el-button size="mini" type="danger" @click="openDeleteRechargeSettingModel(scope.row)">
                    {{ $t('rechargeSetting.delete') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="rechargeSettingManageInfo.conditions.page"
            :page-size="DEFAULT_ROWS"
            layout="total, prev, pager, next"
            :total="rechargeSettingManageInfo.total"
            class="pagination">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-recharge-setting ref="addRechargeSetting" @refresh="listRechargeSettings"></add-recharge-setting>
    <edit-recharge-setting ref="editRechargeSetting" @refresh="listRechargeSettings"></edit-recharge-setting>
    <delete-recharge-setting ref="deleteRechargeSetting" @refresh="listRechargeSettings"></delete-recharge-setting>
  </div>
</template>

<script>
import { listRechargeSetting, exportRechargeOrder as exportRechargeOrderApi } from '@/api/admin/rechargeSettingApi'
import AddRechargeSetting from '@/components/admin/rechargeSetting/addRechargeSetting'
import EditRechargeSetting from '@/components/admin/rechargeSetting/editRechargeSetting'
import DeleteRechargeSetting from '@/components/admin/rechargeSetting/deleteRechargeSetting'

export default {
  name: 'RechargeSetting',
  components: {
    AddRechargeSetting,
    EditRechargeSetting,
    DeleteRechargeSetting
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      rechargeTypeOptions: [
        { label: this.$t('rechargeSetting.PHONE'), value: 'PHONE' },
        { label: this.$t('rechargeSetting.ELECTRIC'), value: 'ELECTRIC' },
        { label: this.$t('rechargeSetting.WATER'), value: 'WATER' },
        { label: this.$t('rechargeSetting.GAS'), value: 'GAS' },
        { label: this.$t('rechargeSetting.PROPERTY'), value: 'PROPERTY' }
      ],
      rechargeSettingManageInfo: {
        rechargeSettings: [],
        total: 0,
        records: 1,
        conditions: {
          rechargeType: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.listRechargeSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {


   async exportRechargeSetting() {
      /* try {
        const params = { ...this.rechargeSettingManageInfo.conditions }
        params.pagePath = 'rechargeSetting'
        params.communityId = '-1'
        params.fileName = '充值配置'
        
        await exportRechargeOrderApi(params)
        this.$message.success('导出任务已提交，请前往下载中心查看')
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (err) {
        console.error('导出充值配置失败', err)
        this.$message.error('导出任务提交失败')
      } */
    },
    listRechargeSettings(page, rows) {
      this.rechargeSettingManageInfo.conditions.page = page
      this.rechargeSettingManageInfo.conditions.row = rows
      
      listRechargeSetting(this.rechargeSettingManageInfo.conditions)
        .then(response => {
          if (response.code === 0) {
            this.rechargeSettingManageInfo.total = response.total
            this.rechargeSettingManageInfo.rechargeSettings = response.data || []
          }
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    handleCurrentChange(currentPage) {
      this.listRechargeSettings(currentPage, this.DEFAULT_ROWS)
    },
    queryRechargeSettingMethod() {
      this.listRechargeSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    openAddRechargeSettingModal() {
      this.$refs.addRechargeSetting.open()
    },
    openEditRechargeSettingModel(rechargeSetting) {
      this.$refs.editRechargeSetting.open(rechargeSetting)
    },
    openDeleteRechargeSettingModel(rechargeSetting) {
      this.$refs.deleteRechargeSetting.open(rechargeSetting)
    },
    getRechargeTypeLabel(type) {
      const option = this.rechargeTypeOptions.find(item => item.value === type)
      return option ? option.label : type
    },
    formatAmountList(amountList) {
      if (!amountList) return []
      return amountList.split(',').map(item => {
        const [discountAmount, faceAmount] = item.split(':')
        return {
          discountAmount: discountAmount || '-',
          faceAmount: faceAmount || '-'
        }
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.card-header-right {
  float: right;
  padding: 3px 0;
}
.query-form {
  margin-top: 10px;
  text-align: left;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.amount-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.amount-item {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}
.amount-label {
  color: #909399;
  margin-right: 4px;
}
.amount-value {
  font-weight: 600;
  margin-right: 4px;
}
.amount-value.discount {
  color: #67c23a;
}
.amount-value.face {
  color: #409eff;
}
.amount-arrow {
  color: #909399;
  margin: 0 8px;
}
.amount-unit {
  color: #909399;
}
</style>